import type { TonyteActivity } from '../types';

// Keeps the previous object for every activity whose content didn't change
// (and the previous array if nothing changed at all), so a background refresh
// doesn't hand every memoized card/marker a brand-new prop.
const activityFingerprints = new WeakMap<TonyteActivity, string>();
function fingerprintActivity(activity: TonyteActivity) {
  let fingerprint = activityFingerprints.get(activity);
  if (fingerprint === undefined) {
    fingerprint = JSON.stringify(activity);
    activityFingerprints.set(activity, fingerprint);
  }
  return fingerprint;
}
export function reuseUnchangedActivities(previous: TonyteActivity[], next: TonyteActivity[]) {
  const previousById = new Map(previous.map(activity => [activity.id, activity]));
  let allReused = previous.length === next.length;
  const merged = next.map((activity, index) => {
    const prior = previousById.get(activity.id);
    if (prior && fingerprintActivity(prior) === fingerprintActivity(activity)) {
      if (previous[index] !== prior) allReused = false;
      return prior;
    }
    allReused = false;
    return activity;
  });
  return allReused ? previous : merged;
}
